import clsx from "clsx";

export default function Layout({ children, className }) {
  return (
    <>
      <div className={clsx(className, "flex min-h-screen max-w-full flex-col")}>
        {children}
      </div>
    </>
  );
}
